module.exports = Ember.Mixin.create
  login:    DS.attr 'string'

  password:               DS.attr 'string'
  password_confirmation:  DS.attr 'string'

  name:     DS.attr 'string'
  phone:    DS.attr 'string'
  avatar:   DS.attr 'mixed'

  organization_id: DS.attr 'number'

  avatarPlaceholder: 'images/account-placeholder@2x.png'

  safeAvatarMedium: (->
    result = @get('avatar.medium_square') or @get('avatarPlaceholder')
    result.htmlSafe()
  ).property('avatar.medium_square')

  safeAvatarSmall: (->
    result = @get('avatar.small') or @get('avatarPlaceholder')
    result.htmlSafe()
  ).property('avatar.small')

  smallAvatarStyle: (->
    photo = @get('safeAvatarSmall')
    result = if photo then "background-image: url(#{photo});" else ''
    result.htmlSafe()
  ).property('safeAvatarSmall')

  mediumAvatarStyle: (->
    photo = @get('safeAvatarMedium')
    result = if photo then "background-image: url(#{photo});" else ''
    result.htmlSafe()
  ).property('safeAvatarMedium')

  loginObserver: (->
    login = @get('login')
    return unless login
    @set('login', login.toLowerCase())
  ).observes('login')

  uploadAvatar: (file) ->
    @fileUpload('avatar', file)
